module.exports = __webpack_public_path__ + "img/calllb.90c6ae4b.png";